import { render, staticRenderFns } from "./AnnouncementViewDialog.vue?vue&type=template&id=6d778c8c&scoped=true&"
import script from "./AnnouncementViewDialog.vue?vue&type=script&lang=js&"
export * from "./AnnouncementViewDialog.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementViewDialog.vue?vue&type=style&index=0&id=6d778c8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d778c8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VCardText,VDialog,VDivider,VIcon,VRow})
